import { FiCheck, FiX } from 'react-icons/fi';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';

export default function Modal({
  isOpen,
  title = '',
  message = '',
  onConfirm,
  onCancel,
  confirmText = 'Aceptar',
  cancelText = '', // por defecto vacío
  children,
  isConfirmDisabled = false,
  isCancelDisabled = false,
  showClose = false
}) {
  // Hooks deben llamarse siempre en el mismo orden: useEffect declarado sin retornos tempranos.
  useEffect(() => {
    if (!isOpen) return; // salimos si no está abierto (pero el hook ya fue llamado)

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKey = (e) => {
      if (e.key === 'Escape') {
        onCancel && onCancel();
      }
    };
    window.addEventListener('keydown', onKey);

    return () => {
      window.removeEventListener('keydown', onKey);
      try {
        document.body.style.overflow = prevOverflow;
      } catch (err) {
        // noop
      }
    };
  }, [isOpen, onCancel]);

  // Si no está abierto, no renderizamos nada (pero los hooks ya se ejecutaron)
  if (!isOpen) return null;

  const modal = (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-content" tabIndex={-1}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: title ? '1rem' : 0 }}>
          {title && <h2 className="modal-title" style={{ margin: 0 }}>{title}</h2>}
          {showClose && onCancel && (
            <button 
              type="button" 
              className="modal-close-button" 
              onClick={onCancel}
              aria-label="Cerrar modal"
            >
              &times;
            </button>
          )}
        </div>
        <div className="modal-body">
          {children || message}
        </div>
        <div className="modal-footer">
          {cancelText && (
            <button
                type="button"
                className="btn-cancel"
                onClick={onCancel}
                disabled={isCancelDisabled}
                style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}
              >
                <FiX size={16} /> {cancelText}
              </button>
          )}
          {onConfirm && (
            <button
                type="button"
                className="btn-confirm"
                onClick={onConfirm}
                disabled={isConfirmDisabled}
                style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}
              >
                <FiCheck size={16} /> {confirmText}
              </button>
          )}
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined' || !document.body) {
    return modal;
  }

  try {
    return createPortal(modal, document.body);
  } catch (err) {
    console.error('Modal portal error, rendering inline:', err);
    return modal;
  }
}